import { Temporal } from '@imago/api-client'
import { MutateButton } from '@imago/api-client-for-react'
import { useInstallApp, useReloadApp } from '@imago/api-client-for-react/pwa'
import { useMutation } from '@tanstack/react-query'
import { useState } from 'react'

export function AppInstallBanner() {
	const installApp = useInstallApp()

	const [_, setBannerJustClosed] = useState(false)
	const bannerClosed = localStorage.getItem('app-banner-closed')
	const closeBanner = useMutation({
		async mutationFn() {
			localStorage.setItem('app-banner-closed', Temporal.Now.instant().toString())
		}
	})

	return installApp && bannerClosed === null ? <section className="app-install banner" role="status">
		<hgroup>
			<img src={new URL('../icons/maskable.png?as=png&height=32', import.meta.url).toString()} height={32} style={{borderRadius: '8px'}}/>
			<p>Imago app</p>
			<div role="toolbar">
				<MutateButton className="low-prio" mutation={installApp}>Install</MutateButton>
				<MutateButton className="low-prio" mutation={closeBanner} onSuccess={() => setBannerJustClosed(true)}>Dismiss</MutateButton>
			</div>
		</hgroup>
	</section> : <></>
}

export function AppUpdateBanner() {
	const reloadApp = useReloadApp()

	return reloadApp ? <section className="app-update banner" role="status">
		<hgroup>
			<p>You are using out of date app.</p>
			<div role="toolbar">
				<MutateButton className="low-prio" mutation={reloadApp}>Reload</MutateButton>
			</div>
		</hgroup>
	</section> : <></>
}
